var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"nav nav-tabs h-m-nav-pages"},[_vm._l((_vm.tabs),function(item,index){return [(!item.hidden)?_c('li',{key:index,staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",class:item.classes,attrs:{"to":item.link,"exact":item.exact}},[_vm._v(_vm._s(item.title))])],1):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }